import React, { useState, useEffect, useRef } from "react";
import ChevronUpIcon from "../icons/ChevronUp"
import ChevronDownIcon from "../icons/ChevronDown"
import ChatsIcon from "../icons/Chats"
import Pinned from "../icons/Pinned"
import IdentityIcon from "../icons/Identity"
import { Utils } from "../../utils"
import { getSessionData } from "../../utils/auth"
import ReactTimeAgo from 'react-time-ago'
import { useNavigate } from "react-router-dom";
import { pinCommunity, unPinCommunity } from "../../core/communities";
import toast from 'react-hot-toast';
import MagnifyingGlassIcon from "../icons/MagnifyingGlass";
import ForumAvatar from "../forum/ForumAvatar";
import CommunityAvatar from "./CommunityAvatar";
import LikeIcon from "../icons/Like";
import PlusCircleIcon from "../icons/PlusCircle";
import CommunityIcon from "../icons/CommunityIcon";
import PostPreview from "../post/PostPreview";
import LoginAlertModal from "../auth/LoginAlertModal";
import EyeIcon from "../icons/Eye";
import { useCurrentCommunity } from "../../utils/CurrentCommunityProvider";
import { getCommunityToDisplay } from "../../core/communities";
import { useAuth } from "../../utils/AuthProvider";
import { useCommunityBadges } from "../../utils/CommunityBadgesProvider";

const CommunityAccordion = ({ position = 1, onPinCommunityChanged, communityBudges: communityBudgesProp = {}, currentCommunity = null }) => {
    const communityBudgesFromContext = useCommunityBadges();
    const communityBudges = Object.keys(communityBudgesFromContext).length > 0
        ? communityBudgesFromContext
        : communityBudgesProp;
    const forumRefs = useRef([]);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true);
    const [isPinLoading, setIsPinLoading] = useState(false);
    const [pinErrors, setPinErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [community, setCommunity] = useState(currentCommunity);
    const [renderedForums, setRenderedForums] = useState(currentCommunity?.forums ?? []);
    const [allForums, setAllForums] = useState(currentCommunity?.forums ?? []);
    const [isFull, setIsFull] = useState(false);
    const [page, setPage] = useState(1);

    const { role } = useAuth();

    const toggleAccordion = () => {
        // setIsOpen(!isOpen);
    };

    const loadForums = async (pageNumber) => {
        // console.log("Loading page ", pageNumber);
        const comm = await getCommunityToDisplay(community._id, pageNumber);
        if (comm && comm.forums && comm.forums.length > 0) {
            setRenderedForums((prev) => {
                const filtered = filterForums(prev.concat(comm.forums));
                return filtered;
            });
            setAllForums((prev) => (prev.concat(comm.forums)));
            setPage(pageNumber);
        } else {
            setIsFull(true);
            // console.log("Terminating loading forums at page ", pageNumber);
            // console.log("Community ", community);
            // console.log("Response forums length: ", comm?.forums?.length??-1);
        }
    }

    useEffect(() => {
        if (currentCommunity) {
            loadForums(page + 1);
        }
    }, [page]);

    const handleOpenForum = (e, communityId, forumId) => {
        e.preventDefault();
        navigate(`/community/${communityId}/forum/${forumId}`);
    }

    const handlePinCommunity = async (e, communityId) => {
        e.preventDefault();
        setPinErrors([]);
        setIsPinLoading(true);
        const inputs = {
            id: communityId
        };
        let response = null;
        response = await pinCommunity(inputs);
        setIsPinLoading(false);
        if (response !== true) {
            return setPinErrors(response);
        }
        toast.success('Post was pinned successfully', {
            icon: '✅'
        });
        onPinCommunityChanged();
    }

    const handleUnPinCommunity = async (e, communityId) => {
        e.preventDefault();
        setPinErrors([]);
        setIsPinLoading(true);
        const inputs = {
            id: communityId
        };
        let response = null;
        response = await unPinCommunity(inputs);
        setIsPinLoading(false);
        if (response !== true) {
            return setPinErrors(response);
        }
        toast.success('Post was unpinned successfully', {
            icon: '✅'
        });
        onPinCommunityChanged();
    }

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            submitSearchForm();
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        submitSearchForm();
    }

    const filterForums = (forums) => {
        const searchBy = searchTerm.trim().toLowerCase();
        if (searchBy.length > 0) {
            let found = [];
            for (let index = 0; index < forums.length; index++) {
                const forum = forums[index];
                const title = forum.title ? forum.title.trim().toLowerCase() : "";
                if (title.indexOf(searchBy) >= 0) {
                    found.push(forum);
                }
            }
            return found;
        }
        return forums;
    }

    const submitSearchForm = async () => {
        setErrors([]);
        setIsLoading(true);
        const filtered = filterForums(allForums);
        setRenderedForums(filtered);
        setIsLoading(false);
    }

    const handlePreviewHover = (refIndex, isEnter) => {
        const parentRef = forumRefs.current[refIndex];
        if (isEnter) {
            parentRef.style.backgroundColor = "";
            parentRef.classList.remove("hover:bg-purple-100");
        } else {
            parentRef.classList.add("hover:bg-purple-100");
        }
    }

    const [isLoginAlertModalOpen, setIsLoginAlertModalOpen] = useState(false);
    const handleClickRequestCommunity = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let loggedInUser = getSessionData();
        if (loggedInUser === null) {
            setIsLoginAlertModalOpen(true);
        } else {
            navigate(`/community-request-form`);
        }
    }

    const handleClickCreatePost = (e, communityId, postId) => {
        e.stopPropagation();
        e.preventDefault();
        let loggedInUser = getSessionData();
        if (loggedInUser === null) {
            setIsLoginAlertModalOpen(true);
        } else {
            navigate(`/forum-post-form/${communityId}/${postId}`);
        }
    }

    const handleClickUserProfile = (userId) => {
        let loggedInUser = getSessionData();
        if (loggedInUser === null) {
            setIsLoginAlertModalOpen(true);
        } else {
            navigate(`/profile/${userId}`);
        }
    }

    const getCommunityStatistics = (community) => {
        let posts = "";
        let replies = "";
        if (community?.forums?.length > 0) {
            posts = community.forums.reduce((acc, forum) => acc + parseInt(forum.count_of_posts ?? 0), 0);
            replies = community.forums.reduce((acc, forum) => acc + parseInt(forum.count_of_replies ?? 0), 0);
        }
        return `${posts} posts, ${replies} replies`;
    }

    if (!community) {
        return <div>No community yet</div>;
    } else {
        //max-w-[calc(100vw-10px)] md:max-w-[calc(100vw-1000px)]
        return (
            <div className={`flex flex-col min-w-full ${role == "admin" ? "rounded-t-md" : "rounded-b-md"}  `}  >
                <LoginAlertModal message="Please log in to continue." isOpen={isLoginAlertModalOpen} closeFun={() => setIsLoginAlertModalOpen(false)} />
                    
                <div
                    className={(!isOpen ? `${role == "admin" ? "" : "rounded-b-md"}` : ` `) + `flex flex-row justify-between accent-bg border-b rounded-none md:rounded-t-md border-b-grey-900 text-white px-1 py-2 `}
                    onClick={(e) => toggleAccordion()} >
                    <div className="flex flex-col justify-start items-start  flex-grow">
                        <div className="font-sans text-gray-900 not-italic tracking-tight font-bold text-sm md:text-md leading-[150%] capitalize flex justify-between items-center w-full">
                            <div className="flex items-center px-1 " >

                                {/* 
                                removed because of the new design
                                {role === "admin" &&
                                    <span className="mr-1">{position}.</span>
                                } */}

                                <div className="min-w-[40px] min-h-[40px] w-[40px] h-[40px] bg-purple-900x flex justify-center items-center text-purple-300 mr-1  ">
                                    <CommunityAvatar community={community} />
                                </div>

                                {community?.is_pinned &&
                                    <div className="mr-1 text-green-600">
                                        <Pinned />
                                    </div>
                                }


                                <a className="hover:underline cursor-pointer text-lg  " >
                                    {community?.title}
                                </a>

                            </div>

                            {/* {position == 1 && */}
                            {/* 
                            removed because of the new design
                            <button onClick={handleClickRequestCommunity} className="flex flex-row justify-between gap-x-1 md:gap-x-2 items-center px-2 text-center text-purple-900 text-xs md:text-sm font-bold  rounded-md cursor-pointer">
                                <CommunityIcon className={"text-whitex"} />
                                <span className="hidden md:inline">Request a Community</span>
                                <span className="inline md:hidden">Community</span>
                            </button> */}
                            {/* } */}
                        </div>
                        {/* <div className={(community?.is_pinned ? '' : 'pl-0') + ` font-sans text-purple-900  not-italic font-medium text-sm leading-[120%] lowercase  pt-1 text-ellipsis overflow-hidden whitespace-nowrap max-w-[300px]`} >
                            {community?.description}
                        </div> */}
                    </div>
                    {/* 
                        removed because of the new design
                        <div className="cursor-pointer accent-text-color flex ">
                        {isOpen === true && <ChevronUpIcon />}
                        {isOpen === false && <ChevronDownIcon />}
                    </div> */}
                </div>
                <div className={`flex flex-col ${role == "admin" ? "rounded-t-md" : "rounded-b-md"}  `}>


                    {community?.forums?.length > 0 &&
                        <form action="#" method="POST" onSubmit={handleSubmit} className="flex flex-col bg-primary-white flex items-center p-1 py-2" >
                            <div className="relative text-gray-400 focus-within:text-gray-600 w-full md:mx-2" id={`search-community-${community._id}-form`} >
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
                                    <MagnifyingGlassIcon className="h-4 w-4" aria-hidden="true" />
                                </div>
                                <input
                                    id={`search-community-${community._id}`}
                                    className="block w-full rounded-full border-1 border-gray-200  bg-gray-300 py-0.5 pl-8 pr-3 text-black mb-0  focus:border-purple-900 focus:ring-0 focus:ring-purple-900  md:text-[0.8rem] md:text-md leading-6 disabled:cursor-progress"
                                    placeholder="Search Community Forums by name"
                                    type="search"
                                    name={`search-community-${community._id}`}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    value={searchTerm}
                                    disabled={isLoading}
                                    aria-label={`search ${community?.title} community input field`}
                                />
                                <button role="button"
                                    type="submit"
                                    disabled={isLoading}
                                    className="cursor-pointer flex justify-center items-center text-white absolute right-0 border border-purple-900 top-[0px] py-1 bg-purple-800 hover:bg-purple-700 font-sm rounded-r-full text-sm px-4 ">
                                    search
                                </button>
                            </div>
                        </form>
                    }
                    <div className={"bg-slate-100 " + (role == "admin" ? "rounded-t-md" : "rounded-b-md")} >
                        {renderedForums.map((forum, index) => {
                            return (
                                <div
                                    key={index}
                                    ref={el => forumRefs.current[index] = el}
                                    onClick={(e) => navigate(`/community/${community._id}/forum/${forum._id}`)}
                                    className={`relative cursor-pointer flex flex-col md:flex-row justify-between border-b  border-gray-200 px-0 md:p-3  bg-slate-100 ${role != "admin" ? 'last:rounded-b-md' : ''}  hover:bg-purple-100  `}

                                >
                                    <div className="flex flex-row items-start w-full ">
                                        {/* <div onClick={(e) => handleOpenForum(e, community._id, forum._id)} className="w-[30px] h-[30px] bg-purple-900x flex justify-center items-center text-purple-300">
                                            <ForumAvatar forum={forum} />
                                        </div> */}
                                        <div className="flex-grow flex flex-col justify-center gap-y-0 w-full ">
                                            <div className="leading-[2.4] flex flex-col pb-1 pl-1 md:pl-0 ">
                                                <div className="text-md font-semibold font-medium flex flex-row items-center justify-between">
                                                    <a className="text-lg hover:underline cursor-pointer truncate  text-purple-900 mt-1"
                                                        href={`/community/${community._id}/forum/${forum._id}`}>
                                                        {forum.title} 
                                                    </a>

                                                    <span className="flex flex-row justify-between gap-x-2 md:gap-x-3 items-center">
                                                        {/* <a className="text-purple-900 text-sm font-bold cursor-pointer flex flex-row items-center gap-x-1"
                                                            href={`/community/${community._id}/forum/${forum._id}`}>
                                                            <EyeIcon className="w-5 h-5" />
                                                            <span>See More</span>
                                                        </a> */}                                                     
                                                    </span>
                                                </div>

                                                <div className="flex flex-row items-center  justify-between gap-x-2">
                                                    <div className="flex flex-row items-center gap-x-2">
                                                        <span className="text-gray-700  text-xxs font-light">{Utils.bigNumberFormat(forum?.count_of_posts ?? 0, 1)} Post{(forum?.count_of_posts ?? 0) == 1 ? '' : 's'}</span>

                                                        <span className="text-gray-700 text-xxs font-light">{Utils.bigNumberFormat(forum?.count_of_replies ?? 0, 1)} Comment{(forum?.count_of_replies ?? 0) == 1 ? '' : 's'}</span>
                                                    </div>

                                                    <button onClick={(e) => { handleClickCreatePost(e, community._id, forum._id) }}
                                                        className="flex flex-row justify-between gap-x-1 items-center  pr-[6px] md:pr-0 text-center text-purple-900 text-md font-bold  rounded-md cursor-pointer">
                                                        <PlusCircleIcon className={"text-whitex"} />
                                                        {/* <span className="hidden md:inline">Create a Post</span> */}
                                                        <span className="">Create a Post</span>
                                                    </button>

                                                </div>

                                            </div>

                                            {((forum?.pinned_post?.post_id ?? null) !== null) &&
                                                <>
                                                    {/* <div className="flex text-sm items-center hidden">
                                                    <div className="text-xs flex flex-row items-center">
                                                        <Pinned className="w-[15px] mr-1 text-sm text-red-600" />
                                                        Pinned Post:
                                                    </div>
                                                    <div className="truncate max-w-[200px] text-purple-900 ml-1">
                                                        <a className="hover:underline cursor-pointer"
                                                            onClick={(e) => { e.stopPropagation(); navigate(`/community/${community._id}/forum/${forum._id}/post/${forum.pinned_post.post_id}`) }}
                                                        >
                                                            {forum.pinned_post?.title}
                                                        </a>
                                                    </div>
                                                </div> */}

                                                    <div className="flex flex-col text-sm items-left  ">
                                                        {/* cbh:40 */}
                                                        <PostPreview parentIndex={index} handlePreviewHover={handlePreviewHover} community={community} forum={forum} isPinned={true} handleClickUserProfile={handleClickUserProfile} postBudges={communityBudges[forum._id] ? communityBudges[forum._id] : []} />
                                                    </div>
                                                </>
                                            }

                                            {(((forum?.pinned_post ?? null) === null) && forum.latest_post) &&
                                                <>
                                                    <div className="flex flex-col text-sm items-left ">
                                                        {/* <div className="truncate max-w-[200px] text-purple-900 ml-1">
                                                        <a className="hover:underline cursor-pointer"
                                                            onClick={(e) => { e.stopPropagation(); navigate(`/community/${community._id}/forum/${forum._id}/post/${forum.latest_post.post_id}`) }}
                                                        >
                                                            {forum.latest_post?.title}
                                                        </a>
                                                    </div> */}

                                                        {/* cbh:40 */}
                                                        <PostPreview parentIndex={index} handlePreviewHover={handlePreviewHover} community={community} forum={forum} isPinned={false} handleClickUserProfile={handleClickUserProfile} postBudges={communityBudges[forum._id] ? communityBudges[forum._id] : []} />


                                                    </div>
                                                </>
                                            }


                                            {forum.count_of_posts > 0 &&

                                                <div className="flex justify-between ">
                                                    {/* todo: delete this section if UI is agreed upon */}
                                                    <div className="flex items-center">
                                                        <span className="hidden text-xs capitalize font-semibold">
                                                            {/* <a
                                                            onClick={(e) => { e.stopPropagation(); navigate(`/profile/${forum.latest_post.user._id}`) }}
                                                            className="hover:underline cursor-pointer">
                                                            {forum.latest_post ? forum.latest_post.user.username + ", " : ""} 

                                                        </a>
                                                        */}
                                                            <span className="text-gray-700  text-xxs font-light">{Utils.bigNumberFormat(forum.count_of_posts, 1)} Posts</span>
                                                        </span>
                                                        <span className="hidden text-xs ml-2 capitalize font-semibold">
                                                            {/* <ReactTimeAgo date={forum.latest_post.date_of_post && forum.latest_post.date_of_post.length > 0 ? forum.latest_post.date_of_post : (new Date()).toDateString()} locale="en-US" /> */}
                                                            <span className="text-gray-700 text-xxs font-light">{Utils.bigNumberFormat(forum.count_of_replies, 1)} Comments {forum.count_of_replies}</span>
                                                        </span>
                                                    </div>
                                                    <div className="text-muted flex flex-row items-center">

                                                        {/* <IdentityIcon />
                                                    <span className="ml-1 mr-3 text-sm">{Utils.comma(forum.count_of_posts)}</span>
                                                    <ChatsIcon />
                                                    <span className="mx-1 text-sm">{Utils.comma(forum.count_of_replies)}</span> */}
                                                    </div>
                                                </div>
                                            }

                                            {forum.count_of_posts == 0 &&
                                                <>
                                                    <div className="flex flex-col text-sm ">
                                                        No posts available
                                                    </div>

                                                    <div className="flex justify-between  ">
                                                        <div className="flex items-center">
                                                            <span className="text-xs capitalize ">
                                                                <a href={`/community/${community._id}/forum/${forum._id}`} className="hover:underline cursor-pointer text-purple-900">
                                                                    Be the first to post
                                                                </a>
                                                            </span>
                                                            <span className="text-sm ml-2">
                                                                &nbsp;
                                                            </span>
                                                        </div>
                                                        <div className="text-muted flex flex-row items-center">
                                                            <IdentityIcon />
                                                            <span className="ml-1 mr-3 text-sm">0</span>
                                                            <ChatsIcon />
                                                            <span className="mx-1 text-sm">0</span>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {(forum._id && community._id) &&
                                                <div className="flex justify-end pt-2 px-1 md:px-0">
                                                    <a className="text-white text-sm font-bold cursor-pointer flex flex-row items-center gap-x-1 bg-purple-900 rounded-md px-2 py-2 self-end align-self-end"
                                                        href={`/community/${community._id}/forum/${forum._id}`}>
                                                        <EyeIcon className="w-5 h-5" />
                                                        <span>See More Posts</span>
                                                    </a>
                                                </div>
                                            }


                                            {/* <div className="text-muted flex flex-row items-center">
                                        <IdentityIcon />
                                        <span className="ml-1 mr-3 text-sm">{Utils.comma(forum.count_of_posts)}</span>
                                        <ChatsIcon />
                                        <span className="mx-1 text-sm">{Utils.comma(forum.count_of_replies)}</span>
                                    </div> */}

                                        </div>


                                    </div>

                                    {forum.count_of_posts > 0 &&
                                        <div className="flex flex-col text-sm items-left py-2 md:hidden px-1 md:px-0">
                                            {/* cbh:40 */}
                                            {/* <PostPreview parentIndex={index} handlePreviewHover={handlePreviewHover} community={community} forum={forum} isPinned={(forum?.pinned_post?.title ?? null) !== null} /> */}
                                        </div>
                                    }


                                    {/* cbh:40 */}
                                    {/* {(communityBudges[forum._id] && communityBudges[forum._id].length > 0) &&
                                        <div className="hidden absolute md:relative text-black text-xs p-1 rounded-sm right-4 md:right-2 md:top-3">
                                            
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                                            </svg>


                                            <span className={`bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white font-bold  rounded-full  -right-[8px] -top-1`} style={{ fontSize: "12px" }} >
                                                {communityBudges[forum._id].length}
                                            </span>
                                        </div>
                                    } */}



                                </div>
                            )
                        }
                        )}
                    </div>

                    {renderedForums.length == 0 &&
                        <div className="flex justify-center py-12 text-gray-400 font-semibold rounded-b-md lg:py-20 bg-white rounded-b-md" >
                            <div className="flex flex-col items-center text-xs sm:text-sm md:text-base">
                                <div>
                                    No Matching Forums
                                </div>
                            </div>
                        </div>
                    }

                </div>
                {role === "admin" &&
                    <div
                        className="bg-primary-white flex flex-row justify-end border-t border-grey-900  rounded-b-md px-3 py-2"
                    >
                        {!community?.is_pinned &&
                            <button role="button"
                                onClick={(e) => handlePinCommunity(e, community._id)}
                                className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 py-1  mr-2 px-3 text-sm font-semibold leading-6 text-white active:text-white/80 btn-gradient-main cursor-pointer" >

                                Pin
                            </button>
                        }

                        {community?.is_pinned &&
                            <button role="button"
                                onClick={(e) => handleUnPinCommunity(e, community._id)}
                                className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 py-1  mr-2 px-3 text-sm font-semibold leading-6 text-white active:text-white/80 btn-gradient-main cursor-pointer" >

                                Unpin
                            </button>
                        }

                        <a
                            href={`/community/${community?._id}/forums/add`}
                            className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 py-1  mr-2 px-3 text-sm font-semibold leading-6 text-white active:text-white/80 btn-gradient-main cursor-pointer" >
                            Add Forum
                        </a>

                        <a
                            href={`/community/${community?._id}/edit`}
                            className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 py-1 px-3 text-sm font-semibold leading-6 text-white active:text-white/80 btn-gradient-main cursor-pointer" >
                            Edit
                        </a>
                    </div>
                }
            </div>
        );
    }
}
export default CommunityAccordion;
